// UpdateUser.jsx
import { useState, useEffect, useContext } from 'react';
import { FiUser, FiMail, FiPhone, FiCheck, FiX } from 'react-icons/fi';
import { updateUserApi } from '../../services/Authentication/UpdateUserAPI';
import { DataProvider } from '../../store/ContextProvider';

export default function UpdateUser({ currentUser, setCurrentUser, setEditUser }) {
  const [form, setForm] = useState({
    fullName: '',
    lastName: '',
    email: '',
    contact: ''
  });
  const [errors, setErrors] = useState({});
  const { BeURL , showAlert } = useContext(DataProvider)

  // init
  useEffect(() => {
    if (!currentUser) return;
    setForm({
      fullName: currentUser.fullName || '',
      lastName:  currentUser.lastName  || '',
      email:     currentUser.email     || '',
      contact:   currentUser.contact   || ''
    });
  }, [currentUser]);

  // validation
  useEffect(() => {
    const e = {};
    if (!form.fullName.trim()) e.fullName = 'Full name is required';
    else if (form.fullName.trim().length < 3)
      e.fullName = 'At least 3 characters';
    if (!form.contact)
      e.contact = 'Contact is required';
    else if (!/^\d{10}$/.test(form.contact))
      e.contact = 'Must be 10 digits';
    setErrors(e);
  }, [form]);

  const manBadge = () => {
    return <span className='text-red-600 text-lg font-medium'> *</span>
  }

  const handleChange = field => e =>
    setForm(f => ({ ...f, [field]: e.target.value }));

  const handleSubmit = () => {
    if (Object.keys(errors).length) {
      return; // prevent submit if errors
    }
    // simulate server save...
    setCurrentUser(u => ({ ...u, ...form }));
    setEditUser(false);

    updateUserApi(BeURL, showAlert, form)
  };

  if(!BeURL){
    return <div>Loading...</div>
  }

  return (
    <div className="max-w-md mx-auto bg-white shadow rounded-lg p-6 space-y-4">
      <h2 className="text-xl font-semibold">Edit User</h2>
      <div className="space-y-4">

        <div>
          <label className="flex items-center gap-2">
            <FiMail className="text-gray-600" />
            <span>Email</span>
          </label>
          <input
            readOnly
            type="email"
            value={form.email}
            onChange={handleChange('email')}
            className="w-full border rounded p-2 mt-1"
          />
          {errors.email && (
            <p className="text-red-600 text-sm mt-1">{errors.email}</p>
          )}
        </div>

        <div>
          <label className="flex items-center gap-2">
            <FiUser className="text-gray-600" />
            <span>Full Name{manBadge()}</span>
          </label>
          <input
            type="text"
            value={form.fullName}
            onChange={handleChange('fullName')}
            className="w-full border rounded p-2 mt-1"
          />
          {errors.fullName && (
            <p className="text-red-600 text-sm mt-1">{errors.fullName}</p>
          )}
        </div>

        <div>
          <label className="flex items-center gap-2">
            <FiPhone className="text-gray-600" />
            <span>Contact{manBadge()}</span>
          </label>
          <input
            type="tel"
            value={form.contact}
            onChange={handleChange('contact')}
            className="w-full border rounded p-2 mt-1"
          />
          {errors.contact && (
            <p className="text-red-600 text-sm mt-1">{errors.contact}</p>
          )}
        </div>
      </div>

      <div className="flex justify-end gap-4 pt-4">
        <button
          onClick={() => setEditUser(false)}
          className="flex items-center gap-1 border rounded px-4 py-2 text-gray-700 hover:bg-gray-100"
        >
          <FiX /> Cancel
        </button>
        <button
          onClick={handleSubmit}
          disabled={Object.keys(errors).length > 0}
          className="flex items-center gap-1 bg-primary-500 text-white rounded px-4 py-2 disabled:opacity-50"
        >
          <FiCheck /> Save
        </button>
      </div>
    </div>
  );
}
